import React from "react";

const Section2 = ({ url }) => {

  const cards = [
    {
      title: "The Timezone Problem Most Offshore Teams Never Solve",
      desc: "Working asynchronously across 8 to 12 time zones means your feedback takes 24 hours to become a code change. Blockers sit overnight. Sprints slip. ExD Digital assigns dedicated shifts aligned to your timezone, whether US Eastern, Pacific, UK, or Canadian hours. Your team works when you work.",
    },
    {
      title: "The Quality Gap That Shows Up Three Months After Contract Signing",
      desc: "Many offshore agencies front-load their best engineers on the sales process and rotate junior resources into delivery. At ExD Digital, the developers you evaluate in the hiring process are the developers who work on your project. Seniority levels are transparent and verifiable before any engagement begins.",
    },
    {
      title: "The Communication Overhead That Kills Productivity",
      desc: "Offshore teams that cannot communicate fluently in English create a hidden management tax on your internal team. Pakistani developers in the tech sector have consistently high English proficiency, particularly in written and technical communication. ExD Digital selects developers with communication quality as a first-class hiring criterion.",
    },
  ];

  return (
    <section className="home-section-2">
      <div className="container overflow-hidden">

        <h2 className="s2-title" data-aos="fade-up">
         Why Offshore Development Has a Bad Reputation, <br/> and Why Most of It Is Earned
        </h2>

        <p className="s2-subtitle" data-aos="fade-up" data-aos-delay="100">
         This section is intentionally direct. Acknowledging the industry's failure patterns before the buyer raises them is the fastest trust-building move on this page. Do not soften it.
         <br/>
         <br/>
         The offshore software development industry has a well-documented problem. Overpromised talent, timezone gaps that turn daily standups into 24-hour lag cycles, communication breakdowns that compound weekly, and delivered code that requires a full rewrite six months later. If you have experienced any of this, your skepticism is completely rational.
        <br/>
        But the failure pattern is not geographic. It is structural. The problem is not that offshore development does not work. The problem is that most offshore agencies are optimized for volume acquisition, not client outcome. They sell you a team and disappear into a ticket queue. ExD Digital is structured differently.
        </p>

        <div className="s2-cards-row" data-aos="fade-up" data-aos-delay="200">
          {cards.map((card, idx) => (
            <div className="s2-card" key={idx}>
              <h3 className="s2-card-title">{card.title}</h3>
              <p className="s2-card-desc">{card.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Section2;